<a class="bottom-page-component" href="#" (click)="scrollToBottom()">
    {{breadcrumb.bottomPage|translate}}        
    <mat-icon (click)="scrollToBottom()" [ngClass]="{'display-icon':windowScrolled}">
      arrow_circle_down
    </mat-icon>   
</a>